var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOicLogoMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#oic-logo-mobile_svg__clip0_456_1145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.278 23.406c-1.98 1.5-3.58 4.729-3.58 7.218v6.82c0 2.479 1.62 3.299 3.61 1.819l22.336-16.577c1.99-1.48 1.99-3.88 0-5.36L14.308.74c-2-1.48-3.61-.67-3.61 1.82v8.489c0 1.32.85 3.04 1.9 3.839l3.02 2.3c1.89 1.44 1.89 3.769 0 5.199l-1.35 1.02h.01z",
    fill: "#48BDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58 23.406C1.6 24.906 0 28.135 0 30.624v6.82c0 2.479 1.62 3.299 3.61 1.819l22.336-16.577c1.99-1.48 1.99-3.88 0-5.36L3.609.74C1.62-.74 0 .07 0 2.56v8.489c0 1.32.85 3.04 1.9 3.839l3.02 2.3c1.889 1.44 1.889 3.769 0 5.199l-1.35 1.02h.01z",
    fill: "#98BC3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.946 17.317L10.698 5.998v5.05c0 1.32.85 3.04 1.9 3.839l3.03 2.3c1.89 1.44 1.89 3.769 0 5.199l-1.35 1.02c-1.98 1.5-3.58 4.729-3.58 7.218v3.37l15.248-11.318c1.99-1.48 1.99-3.88 0-5.36z",
    fill: "#419B4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "oic-logo-mobile_svg__clip0_456_1145"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h38.136v40H0z"
  })))));
}
export default SvgOicLogoMobile;